/** @module Enums */ /** typedoc */

export enum AssetPurchaseFormatEnum {
    upsell = "CTA_SaaS_ALC",
    lomp3 = 'lomp3',
    himp3 = 'himp3',
    wav = 'wav',
    hdwav = 'hdwav',
}
